import PromoPrograms from './PromoPrograms';
import PromoProgramsDescription from './PromoProgramsDescription';
import PromoProgramsPicture from './PromoProgramsPicture';

export { PromoPrograms, PromoProgramsDescription, PromoProgramsPicture };
